export type Consult = {
  selectedSalesLeads: {[key: string]: boolean}
}

export const isAnySalesLeadSelected = (consult : Consult) => {
  return consult.selectedSalesLeads
    ? Object.values(consult.selectedSalesLeads).includes(true) 
    : false 
}